"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendProductToURL = exports.detectProductReferral = exports.detectPage = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importDefault(require("./Logger"));
function detectUtm({ searchParams }) {
    let facets = null;
    Common_1.UTM_PARAMETERS.forEach((parameter) => {
        const tag = searchParams.get(parameter);
        if (!tag)
            return;
        if (!facets) {
            facets = {};
        }
        facets[parameter] = tag;
    });
    return facets;
}
function detectPage(base) {
    const url = new URL(base);
    return Object.assign(Object.assign({ path: url.pathname, url: url.toString() }, (url.search ? { search: url.search } : undefined)), detectUtm(url));
}
exports.detectPage = detectPage;
const REFERRER_PARAMETERS = [
    ["REFERRER_ID", "adp_referrer_id"],
    ["REFERRER_NAME", "adp_referrer_name"],
    ["REFERRER_SESSION_ID", "adp_referrer_session"],
    ["REFERRER_VERSION", "adp_referrer_version"],
];
function detectProductReferral(base) {
    const url = new URL(base);
    const { searchParams } = url;
    let facets = null;
    let emptyCount = 0;
    REFERRER_PARAMETERS.forEach(([facetKey, searchKey]) => {
        const value = searchParams.get(searchKey);
        if (!value) {
            emptyCount += 1;
            return;
        }
        if (!facets) {
            facets = {};
        }
        facets[facetKey] = value;
    });
    if (emptyCount !== REFERRER_PARAMETERS.length) {
        Logger_1.default.warn("Referrer is incomplete");
    }
    return facets;
}
exports.detectProductReferral = detectProductReferral;
function appendProductToURL(base, product, session) {
    const url = new URL(base);
    const search = new URLSearchParams(url.search);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { id, name, build_id } = product;
    search.set("adp_referrer_id", id);
    search.set("adp_referrer_name", name);
    if (session) {
        search.set("adp_referrer_session", session);
    }
    if (build_id) {
        search.set("adp_referrer_version", build_id);
    }
    url.search = search.toString();
    return url.toString();
}
exports.appendProductToURL = appendProductToURL;
